

































































import Vue from 'vue';
import ComponentPage from '@/components/page-constructor/ComponentPage.vue';
import ComponentUsageExample from '@/components/page-constructor/ComponentUsageExample.vue';
import ACheckbox from '@/components/ACheckbox.vue';

interface Data {
  basicUsageChecked: boolean;
  modelAsArrayChecked: string[];
  labelSlotChecked: boolean;
  indeterminateStateChecked: boolean;
  indeterminateStateIndeterminate: boolean;
}

export default Vue.extend({
  name: 'Checkbox',
  components: {
    ComponentPage,
    ComponentUsageExample,
    ACheckbox,
  },
  data(): Data {
    return {
      basicUsageChecked: false,
      modelAsArrayChecked: ['first'],
      labelSlotChecked: false,
      indeterminateStateChecked: false,
      indeterminateStateIndeterminate: true,
    };
  },
});
